export class ProfilePassword {
	OldPassword: string;
	NewPassword: string;
}